import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
const LoginModal = () => {
  const [LgInFrom, setLgInFrom] = useState("Login");
  const [modal, setModal] = useState(false);
  const [ModalText, setModalText] = useState(<LoginForm />);
  const toggle = () => {
    setModal(!modal)
    setModalText(<LoginForm />)
    setLgInFrom("Login")
  };
  const SignUp = () => {
    setModalText(<SignUpForm />);
    setLgInFrom("SignUp")
  };
  return (
    <div>
      <Button outline color="light" onClick={toggle} >Login</Button>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{LgInFrom}</ModalHeader>
        <ModalBody>
          {ModalText}
        </ModalBody>
        {LgInFrom === "Login" ? <ModalFooter>
          <Button color="primary" onClick={SignUp} outline >Sign Up</Button>
        </ModalFooter> : ""}
      </Modal>
    </div>
  );
}
export default LoginModal;